const encodeFormData = (data) =>
  new URLSearchParams(
    Object.entries(data).reduce((entries, [key, value]) => {
      if (Array.isArray(value)) {
        entries[key] = value.join(', ');
      } else {
        entries[key] = value ?? '';
      }
      return entries;
    }, {})
  ).toString();

export const submitNetlifyForm = async (formName, data) => {
  const response = await fetch('/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: encodeFormData({
      'form-name': formName,
      ...data
    })
  });

  if (!response.ok) {
    throw new Error(`Netlify form submission failed for ${formName}`);
  }

  return response;
};
